module.exports = __webpack_public_path__ + "static/media/email.0866b58b.svg";